import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../utils/sizes';
import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const LOGO_DIMENSIONS = {
  [HD]: {
    width: SCREEN_HEIGHT[HD] - safetyMargins.horizontal[HD] * 2,
    height: 136,
  },
  [FULL_HD]: {
    width: SCREEN_HEIGHT[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
    height: 200,
  },
};

export const LOGO_MARGIN_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const TEXT_WIDTH = {
  [HD]: 640,
  [FULL_HD]: 980,
};

export const SERVICE_ICON_HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const colors = {
  background: makeThemeColor(TERTIARY, 0.8),
};

export const getTitleFont = screenSize => getFont(FONT.TOKYO_4, screenSize);

export const getScrollTop = ({ isLogoVisible, isTitleVisible, isServiceIconVisible, screenSize }) => {
  let result = 0;

  if (isLogoVisible) {
    result += LOGO_DIMENSIONS[screenSize].height + LOGO_MARGIN_BOTTOM[screenSize];
  } else if (isTitleVisible) {
    result += getTitleFont(screenSize).lineHeight;
  }

  if (isServiceIconVisible) {
    result += SERVICE_ICON_HEIGHT[screenSize];
  }

  return result;
};

export const getServiceIconViewBox = screenSize => ({
  h: SERVICE_ICON_HEIGHT[screenSize],
});

export const getContainerHeight = screenSize => SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] * 2;

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const containerHeight = getContainerHeight(screenSize);

  return {
    alpha: 0,
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Overlay: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode],
    },
    ContentContainer: {
      h: containerHeight,
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      Top: {
        Title: {
          text: {
            ...getFont(FONT.TOKYO_4, screenSize),
            maxLinesSuffix: '...',
            wordWrapWidth: TEXT_WIDTH[screenSize],
            maxLines: 1,
          },
        },
        Logo: {
          flexItem: {
            marginBottom: LOGO_MARGIN_BOTTOM[screenSize],
          },
        },
        ServiceIcon: {},
        flex: {
          direction: 'column',
        },
      },
      Scroll: {
        w: TEXT_WIDTH[screenSize],
        h: containerHeight,
        y: 0,
      },
    },
    ExitButton: {
      mountX: 1,
      x: SCREEN_WIDTH[screenSize] - safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
    },
  };
};

export const getProgramInformationFocusedStyle = () => ({
  smooth: {
    alpha: 1,
  },
});

export const getProgramInformationUnFocusedStyle = () => ({
  smooth: {
    alpha: 0,
  },
});
